/* eslint-disable no-console */
import React from "react";
import { Modal } from "@vds/modals";
import Icon from "@vds/icons";
import { Title } from "@vds/typography";
import { css } from "@emotion/react";
import { FlexRow, SmallText } from "../utility";
import styled from "styled-components";

export const StyledModal = css`
  max-height: 99vmin;
  padding: 2rem 1rem 1rem 2rem;
  padding-right: 2px;
  border-radius: 0.5rem;
  max-height: 80%;
  @media (max-width: 767px) {
    width: 560px !important;
    height: auto;
    min-height: 14.5rem;
    padding: 1rem 1rem 1rem 1rem;
    padding-right: 2px;
  }
  @media screen and (min-width: 700px) and (max-width: 909px) {
    width: 70vw !important;
    margin-left: 50px;
  }
  & mark {
    background-color: transparent !important;
  }
  & footer {
    padding: 0;
  }
`;
const CustomSmallText = styled(SmallText)`
  margin-bottom: 0.5rem !important;
  font-family: Verizon-NHG-eTX !important;
`;

const CustomModal = ({ isOpen, title = "Title", description, closeModal = () => {}, children }) => {
  if (!isOpen) return null; // Prevents rendering when isOpen is false
  return (
    <Modal
      role="dialog"
      ariaLabel={title}
      hideCloseButton={false}
      opened={isOpen}
      disableOutsideClick
      css={StyledModal}
      fullScreenDialog={false}
      closeButton={
        <FlexRow justifyContent="space-between" onClick={(event) => event.preventDefault()}>
          <div>
            <div>
              <Title size="medium">{title}</Title>
            </div>
            {!!description?.length && (
              <CustomSmallText>
                <p>{description}</p>
              </CustomSmallText>
            )}
          </div>
          <div
            onClick={() => {
              closeModal(false);
            }}
            aria-label="close"
            style={{ marginRight: "1rem", marginTop: "0.3rem" }}
          >
            <Icon
              aria-label="close"
              alt="close-icon"
              role="img"
              name="close"
              size="medium"
              color="#000000"
              style={{ cursor: "pointer", outline: "none" }}
            />
          </div>
        </FlexRow>
      }
    >
      {children}
    </Modal>
  );
};
export default CustomModal;
